import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import QuiSommesNous from "../pages/qui-sommes-nous/page";
import NosActions from "../pages/nos-actions/page";
import PublicsAccompagnes from "../pages/publics-accompagnes/page";
import PartenariatsImpact from "../pages/partenariats-impact/page";
import Contact from "../pages/contact/page";
import Layout from "../components/Layout";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/qui-sommes-nous",
        element: <QuiSommesNous />,
      },
      {
        path: "/nos-actions",
        element: <NosActions />,
      },
      {
        path: "/publics-accompagnes",
        element: <PublicsAccompagnes />,
      },
      {
        path: "/partenariats-impact",
        element: <PartenariatsImpact />,
      },
      {
        path: "/contact",
        element: <Contact />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
